(function () {
    "use strict";


    // @ngInject
    function MemberReferralsManagerCtor(APIService, Routes, $q, ModelFactory) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);
        this.Routes = Routes;
        this.ModelFactory = ModelFactory;
    }

    Services.MemberReferralsManager = Class(Services.BaseModelManager, {

        constructor: MemberReferralsManagerCtor,

        getUserReferrals: function getUserReferrals(user, referrals) {
            var data = {
                referrer_user_id: user._id,
            };
            var url = this.Routes.v2_user_referrals_path();

            return this.apiFetchCollection(url, data, referrals, true);
        },

        getUserReferralStats: function getUserReferralStats(user) {
            var data = {
                referrer_user_id: user._id,
            };
            var url = this.Routes.v2_user_referral_stats_path();

            return this.apiFetchCollection(url, data);
        },

        // generateNewCustomShortCode: function generateNewCustomShortCode(inviter) {
        //     var url = this.Routes.v2_generate_new_custom_short_code_path();
        //     var data = {
        //         referrer_user_id: inviter._id,
        //         promo_code: promoCode
        //     };
        //     return this.apiFetch(url, data);
        // },
        referUsersByEmail: function referUsersByEmail(inviter, emails, referrals, message) {
            var data = {
                emails: emails,
                referrer_user_id: inviter._id,
                message: message,
            };
            var url = this.Routes.v2_refer_users_by_email_path();
            
            var promise = this.apiCreate(url, data);
            promise.then(function updateReferrals(resp) {
                if (referrals) {
                    referrals.mixinFrom(resp.data, null, false, true, true);
                }
            });
            return promise;
        },

        getReferralsByIds: function getReferralsByIds(referralsCollection, referralIds) {
            var data = {
              referral_ids: referralIds
            };
            var url = this.Routes.v2_referrals_by_ids_path();
            var promise = this.apiFetch(url, data);
            promise.then(function success(resp) {
                resp.data.forEach(function (object) {
                    var obj = referralsCollection.find(function(referral){
                        return object._id === referral._id;
                    });
                    obj.mixinFrom(object, null, false, true);
                });
            });
            return promise;
        },

        getPendingCommissionReferrals: function getPendingCommissionReferrals(pendingCommissionApprovalReferrals) {
            var data = {};
            var url = this.Routes.v2_pending_commission_referrals_path();
            var promise = this.apiFetch(url, data);
            promise.then(function success(resp) {
                pendingCommissionApprovalReferrals.mixinFrom(resp.data, null, false, true, true, true);
            });
            return promise;
        },

        getPendingCommissionPayoutReferrals: function getPendingCommissionPayoutReferrals(pendingCommissionPayoutReferrals) {
            var data = {};
            var url = this.Routes.v2_pending_commission_payout_referrals_path();
            var promise = this.apiFetchCollection(url, data);
            promise.then(function success(resp) {
                pendingCommissionPayoutReferrals.mixinFrom(resp.data, null, false, true, true, true);
            });
            return promise;
        },

        getCampaignDetails: function getCampaignDetails(user, campaignModel, campaignUid) {
            var data = {
                user_id: user._id,
                campaign_uid: campaignUid
            };
            var url = this.Routes.v2_campaign_details_path();
            return this.apiFetch(url, data, campaignModel, true);
        },

        sendReferralReminder: function sendReferralReminder(user, referral) {
            var data = {
                user_id: user._id,
                referral_id: referral._id
            };

            var url = this.Routes.v2_send_referral_reminder_path();
            return this.apiUpdate(url, data, referral, true);
        },

        getReferralSuggestions: function getReferralSuggestions(user, includeGoogleContacts) {
            var data = {
                user_id: user._id,
                include_google_contacts: includeGoogleContacts
            };
            var url = this.Routes.v2_referral_suggestions_path();
            return this.apiFetch(url, data);
        },

        createReferral: function createReferral(referrerEmail, referredEmail, source, status, shouldSendEmail) {
            var referral = this.ModelFactory.newModel('MemberReferralModel');
            var url = this.Routes.v2_create_referral_path();
            var data = {
                referrer_email: referrerEmail,
                referred_email: referredEmail,
                source: source,
                status: status,
                send_email: shouldSendEmail
            };
            this.apiCreate(url, data, referral, true);
            return referral;
        },

        saveReferral: function saveReferral(data) {
            var url = this.Routes.v2_save_referral_path();
            return this.apiUpdate(url, data);
        },

        updatePersonalInviteMessage: function updatePersonalInviteMessage(campaign, message) {
            var data = {
                message: message,
            };
            var url = this.Routes.v2_update_personal_invite_message_path();
            return this.apiUpdate(url, data, campaign, true, null, 'waitForLast');
        },

        getReferralCode: function getReferralCode(code) {
            var url = this.Routes.v2_get_referral_code_path(code);
            return this.apiFetch(url);
        }
    });
}());